import $ from 'jquery';
if(document.querySelector('.hoverchange')){

  var ww = $(window).width();
  if(ww >= 768) {
    $('.hoverchange').hover (function(e) {
      let id = $(this).attr('id');
      $('#Tabimg-'+ id).animate({opacity:1}, 115);
    }, function(){
      let id = $(this).attr('id');
      $('.Tabimg').animate({opacity:0}, 115);
    });
  }
}